<script>
import AdvancedSearch from '@/components/search/advanced/AdvancedSearch.vue'
import LibraryMetadataMixin from '@/components/search/advanced/LibraryMetadataMixin.vue'

export default {
  name: 'ResearchReportsAdvancedSearch',
  mixins: [LibraryMetadataMixin],
  extends: AdvancedSearch,
  data() {
    return {}
  },
  computed: {
    limitFieldConfig() {
      return [
        this.standardField('australian_content'),
        this.standardField('australian_electronic_publications'),
        this.standardField('isbn'),
        this.standardField('issn'),
        this.standardField('public_tag'),
        this.standardField('format'),
        this.standardField('place'),
        this.standardField('title'),
        this.generateField('Funder', this.generateSelectSubfieldFromFacet('funder', 'Any')),
        this.standardField('access'),
        this.standardField('rights'),
        this.standardField('category'),
        this.standardField('year'),
        this.standardField('language'),
        this.standardField('austlang'),
        this.standardField('illustration_type'),
        this.standardField('word_count'),
        this.standardField('library'),
      ]
    },
  },
}
</script>
